
import { configState, configGetters, dashboardGetters } from "~/store/helpers";
export default {
  props: {
    userId: String,
    field: String,
    activeTab: String,
    isEditing: Boolean,
  },
  data() {
    return {
      mActiveTab: this.$props.activeTab,
      selected: "",
    };
  },
  watch: {
    activeTab(val) {
      //
    },
    $route: {
      handler(val) {
        this.mActiveTab = this.$props.activeTab;
        if (val.fullPath.includes("/reports")) {
          let arr = val.fullPath.split("/");
          if (
            val.fullPath.includes("ccm") ||
            val.fullPath.includes("general")
          ) {
            arr.pop();
          }
          this.mActiveTab = arr;
          this.mActiveTab = this.mActiveTab[this.mActiveTab.length - 1];
        }
      },
    },
    isEditing(editingValue) {
      let isTrue =
        this.$route.path == "/" && this.$route.name == "index"
          ? true
          : this.$route.name == "index-name"
          ? true
          : false;
      if (!isTrue) return;
      let tabLength = this.tabs.length >= 15 ? "280px" : "200px";
      this.$refs.tabs.$el.style.maxWidth = editingValue
        ? "calc(100% - 280px)"
        : `calc(100% - ${tabLength})`;
    },
  },
  mounted() {
    let isTrue =
      this.$route.path == "/" && this.$route.name == "index"
        ? true
        : this.$route.name == "index-name"
        ? true
        : false;
    if (!isTrue) return;
    let tabLength = this.tabs.length >= 15 ? "280px" : "200px";
    this.$refs.tabs.$el.style.maxWidth = this.isEditing
      ? "calc(100% - 280px)"
      : `calc(100% - ${tabLength})`;
  },
  computed: {
    ...configGetters,
    ...dashboardGetters,
    tabs() {
      return this.$props.field == "dashboard"
        ? this.getOrgBoards().map((e) => ({
            ...e,
            id: e.id,
            display_name: e.name,
            display: true,
          }))
        : this.getTabs(this.$props.field);
    },
  },
};
